import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Info = () => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [openAccordions, setOpenAccordions] = useState({});

  // FAQ data
  const faqData = [
    {
      question: "Is what I'm seeing on the screen up to date and synced with current data in PLEX?",
      answer: "Yes, the app is set to update once every minute, pulling fresh data from the PLEX app so what you see on the screen should always match what you see in PLEX."
    },
    {
      question: "Where is the app displayed?",
      answer: "On 60\" TV screens in the Quality Assurance space, Shop floor and Main Cleanroom. You may also access the app as it is displayed in each of those locations from any browser."
    },
    {
      question: "How do I access the app on my desktop browser?",
      answer: "Open any internet browser (Chrome, Firefox, Safari) and go to https://andonx.strandproducts.com. To resize, follow the following steps: Right click and select inspect. Use settings inspect at 2560 x 3860 and 20%. Let the app refresh."
    },
    {
      question: "What is the URL for the app?",
      answer: "https://andonx.strandproducts.com"
    },
    {
      question: "What is the URL for the reporting tool?",
      answer: "https://andonx.strandproducts.com/report"
    },
    {
      question: "What is the URL for the admin tool?",
      answer: "https://andonx.strandproducts.com/admin"
    },
    {
      question: "What is the URL for FAQ?",
      answer: "https://andonx.strandproducts.com/info/"
    },
    {
      question: "Where can I find the feedback form?",
      answer: "The feedback form is a modal at the top of this page. Click the 'Submit Feedback' button to open the modal."
    },
    {
      question: "How do I switch between test data and live data?",
      answer: "Go to https://andonx.strandproducts.com/. If needed, refresh to return to the home screen. In the lower right corner, click either the 60 second countdown timer (to switch to Production) or the circle icon (to switch to Test). This will open a modal box where you can use the toggle to select either \"Production\" or \"Test\"."
    },
    {
      question: "How do I contact support to report an emergency?",
      answer: ""
    },
    {
      question: "How do I submit my comments or feedback about the app?",
      answer: "The best way to submit your comments or feedback is through the feedback form at the top of this page by clicking the 'Submit Feedback' button.\n\nIf you prefer, you may also email us directly:\n\n- For outages: andonx+urgent@strandproducts.com\n- For error messages or bugs: andonx+errors@strandproducts.com\n- For TV display issues (please specify which display: QA/Shop/Cleanroom): andonx+display@strandproducts.com\n- To request changes to reporting: andonx+reports@strandproducts.com\n- For design or feature requests: andonx+design@strandproducts.com\n\nFor all other questions or comments, you can also post in the #andonx-general Slack channel."
    },
    {
      question: "How do I report an urgent outage?",
      answer: "Compose a new email to andonx+urgent@strandproducts.com to report an outage."
    },
    {
      question: "How do I export data?",
      answer: "Open https://andonx.strandproducts.com/report. Click \"download data\" button."
    },
    {
      question: "Where can I find app documentation and training material?",
      answer: ""
    },
    {
      question: "How does what I'm seeing relate to information that can be found inside the PLEX app?",
      answer: ""
    },
    {
      question: "Will changing data in the test environment change data in Plex?",
      answer: ""
    },
    {
      question: "What email address should we use to reach the developers?",
      answer: "andonx@strandproducts.com"
    },
    {
      question: "Which Slack channel should we use to ...",
      answer: ""
    },
    {
      question: "How can I access the app when I'm working offsite?",
      answer: ""
    },
    {
      question: "What format will data be exported as?",
      answer: "The exported data is a one-to-one copy of the Ticket Events tables in the database. It is exported as a CSV (Comma-Separated Values) file, which can be opened with Microsoft Excel, Google Sheets, or any other spreadsheet software that supports CSV files."
    },
    {
      question: "What's next in terms of development improvements to come?",
      answer: "We're planning to add more robust reporting options, sound alerts for new and completed tickets, and alternate data views to help different users access and understand the information that matters most to them."
    },
    {
      question: "Who is qualified to make updates to the status of a job?",
      answer: ""
    },
    {
      question: "Who is qualified to export data?",
      answer: ""
    }
  ];

  // Add "info-page" class to body when component mounts
  useEffect(() => {
    document.body.classList.add('info-page');

    // Remove class when component unmounts
    return () => {
      document.body.classList.remove('info-page');
    };
  }, []);

  // Handle Escape key to close modal
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && showFeedbackModal) {
        setShowFeedbackModal(false);
      }
    };

    if (showFeedbackModal) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [showFeedbackModal]);

  const openFeedbackModal = () => {
    setShowFeedbackModal(true);
  };

  const closeFeedbackModal = () => {
    setShowFeedbackModal(false);
  };

  const toggleAccordion = (index) => {
    setOpenAccordions(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="info-container">
      <div className="info-header">
        <h1>Information Center</h1>
        <p>for <img src="/images/andonx-logo-mini.png" alt="AndonX Logo" /></p>
      </div>

      <div className="info-content">
        <div className="info-section feedback-section">
          <h2 className="info-section-title">Feedback</h2>
          <button
            className="feedback-button"
            onClick={openFeedbackModal}
          >
            <i className="fas fa-comment-dots"></i> Submit Feedback
          </button>
        </div>

        <div className="info-section faq-section">
          <h2 className="info-section-title">Frequently Asked Questions</h2>
          <div className="faq-accordions">
            {faqData.map((faq, index) => (
              <div key={index} className={`faq-accordion-item ${openAccordions[index] ? 'open' : ''}`}>
                <button
                  className="faq-accordion-header"
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openAccordions[index]}
                >
                  <span className="faq-question">{faq.question}</span>
                  <span className="faq-accordion-icon">
                    <i className={`fas fa-chevron-${openAccordions[index] ? 'up' : 'down'}`}></i>
                  </span>
                </button>
                {openAccordions[index] && (
                  <div className="faq-accordion-content">
                    <div className="faq-answer">
                      {faq.answer ? (
                        faq.answer.split('\n').map((line, lineIndex) => (
                          <p key={lineIndex}>{line || '\u00A0'}</p>
                        ))
                      ) : (
                        <p className="faq-answer-empty">This app is still in development. Please check back soon for updates.</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="back-link-container">
          <Link to="/" className="back-link">
            Back to Dashboard
          </Link>
        </div>
      </div>

      {/* Feedback Modal */}
      {showFeedbackModal && (
        <div className="feedback-modal-overlay" onClick={closeFeedbackModal}>
          <div className="feedback-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="feedback-modal-header">
              <h3>Feedback</h3>
              <button className="feedback-modal-close" onClick={closeFeedbackModal}>×</button>
            </div>
            <div className="feedback-modal-body">
              <div className="gravity-form-container">
                <iframe
                  src="https://strandproducts.com/andonx-feedback/"
                  width="100%"
                  height="2000"
                  frameBorder="0"
                  scrolling="auto"
                  title="AndonX Feedback Form"
                  className="gravity-form-iframe"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Info;

